export default __webpack_public_path__ + "static/char-v-43-941cf31594c6288933e9c2b9c45df3a4.webp";